// extracted by mini-css-extract-plugin
export var cardLayout = "_1p-1";
export var paginationContainer = "_1p-0";